export default __webpack_public_path__ + "static/media/Carbon.a5c55d33.gif";